<template>
	<div class="omapi-card__third omapi-campaign-settings__right-column">
		<common-card v-if="!hasError" class="omapi-rules-list__wrapper">
			<template #title>Display Rules Summary</template>
			<campaigns-rule-summary-wrap :campaign="campaign" />
		</common-card>
	</div>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'
import { mapGetters } from 'vuex'

export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * Campaign Id
		 */
		campaignId : {
			type : String,
			default: '',
		},
	},
	computed : {
		...mapGetters('campaigns', [ 'getCampaign', 'hasError' ]),
		/**
		 * Get the campaign object.
		 * @returns {Object} The campaign object.
		 */
		campaign () {
			return this.getCampaign(this.campaignId)
		},

	},
};
</script>
